import { environment } from "src/environments/environment";

export const MICROSOFT_ACCOUNT_ENDPOINT = environment.msalResourceMap[0].resourceURL;
export const IAPI_ENDPOINT = environment.msalResourceMap[1].resourceURL;
export const OWU_URL = environment?.owuURL;
export const LIVEKIT_URL = environment?.livekitURL;

export const OWU_ADMIN_API_KEY = environment?.owuAdminApiKey;

export const testUserID = 'ae37af9b-fae0-4e16-98fd-e2412b1b778a';

export const STATUS = {
  NEW: 0,
  PENDING: 1,
  REJECTED: 2,
  APPROVED: 3,
  DELETED: 4,
  DRAFT: 5,
  CLOSED: 6,
  RESUBMITTED: 7,
  EDITED: 8,
  REOPENED: 9,
  RESOLVED: 10,
} as const;

export const STATUS_TEXT = {
  [STATUS.NEW]: 'New',
  [STATUS.PENDING]: 'Pending',
  [STATUS.REJECTED]: 'Rejected',
  [STATUS.APPROVED]: 'Approved',
  [STATUS.DELETED]: 'Deleted',
  [STATUS.DRAFT]: 'Draft',
  [STATUS.CLOSED]: 'Closed',
  [STATUS.RESUBMITTED]: 'Resubmitted',
  [STATUS.EDITED]: 'Edited',
  [STATUS.REOPENED]: 'Reopened',
  [STATUS.RESOLVED]: 'Resolved',
};

export const PRIORITY = {
  HIGH: 1,
  MEDIUM: 2,
  LOW: 3,
}

export const USER_ROLES = [
  {
    "id": 0,
    "name": "Admin"
  },
  {
    "id": 1,
    "name": "User"
  },
  {
    "id": 2,
    "name": "Third Party"
  },
  {
    "id": 3,
    "name": "Global Admin"
  },
  {
    "id": 4,
    "name": "MICROSVC"
  },
  {
    "id": 5,
    "name": "CS"
  }
  ,
  {
    "id": 6,
    "name": "Yakuin"
  }
];

export const MARK_MAP = {
  0: "G", // ギャランティ
  1: "O", // OPS
  2: "A", // ACB
  3: "ガ", // ガバナ関連
  4: "ア", // アドバイス
  5: "水", // 被水
  6: "焼", // 焼損
  7: "他", // その他
};

export const CLAIM_TAG_OPTIONS = ["OPS", "ACB", "ガバナ関連", "被水", "焼損", "その他"];
export const MAX_ATTACHMENT_BYTES = 50_000_000;
